<template>
  <div>
    <el-row style="margin-top: 20px">
      <el-col>
        <el-button size="medium" @click="addData">新增</el-button>
      </el-col>
    </el-row>
    <!-- 下列库存不足，请先采购 -->
    <p style="color: red; font-size: 22px; font-weight: bold">
      下列库存不足，请先采购
    </p>
    <el-table :data="noWareDate" :span-method="objectSpanMethod" border stripe>
      <el-table-column prop="ID" label="序号" width="50" />
      <el-table-column label="商品名称" prop="PRODUCT_NAME"></el-table-column>
      <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
      <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
      <el-table-column label="所需数量" prop="NEED_COUNT"></el-table-column>
      <el-table-column label="批次" prop="BATCH"></el-table-column>
      <el-table-column label="库存数量" prop="WAREHOUSE_COUNT"></el-table-column>
      <el-table-column label="出库数量" prop="DELIVER_COUNT">
        <template slot-scope="scope">
          <span v-if="scope.row.DELIVER_COUNT == -1"></span>
          <span v-else>{{ scope.row.DELIVER_COUNT }}</span>
        </template>
      </el-table-column>
      <el-table-column label="缺少数量" prop="LACK_COUNT"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="updateData(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" style="float: right; margin-top: 20px" class="dialog-footer">
      <el-button size="small" type="default" v-if="updateStatus === 0" disabled @click="noSubmit">确 定</el-button>
      <el-button size="small" type="default" v-else @click="noSubmit">确 定</el-button>
    </span>
    <el-dialog :visible.sync="dialogVisible" title="修改出库信息" center>
      <el-form ref="form" :model="form" label-width="120px" size="small" :inline="true">
        <el-form-item label="产品名称：">
          <span>{{ name }}</span>
        </el-form-item>
        <el-form-item label="单位：">
          <span>{{ pro_type }}</span>
        </el-form-item>
        <el-form-item label="所需数量：">
          <span>{{ out_count }}</span>
        </el-form-item>
        <el-form-item label="库存数量：">
          <span>{{ total_count }}</span>
        </el-form-item>
        <el-table :data="outwareDate" border stripe>
          <el-table-column label="批次" prop="BATCH"></el-table-column>
          <el-table-column label="出库数量">
            <template slot-scope="scope">
              <el-input type="number" min="0" v-model="scope.row.NEW_COUNT"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="现有库存" prop="WAREHOUSE_COUNT"></el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  stockOutDetailFun, print, updatestockOutFun, updatestockDataFun,
} from 'api/warehouseManager';

export default {
  data() {
    return {
      updateStatus: 0,
      noWareDate: [],
      noDetailVisible: false,
      name: '',
      pro_type: '',
      deliverId: '',
      spanArr: [],
      position: 0,
      positionSto: 0,
      listData: [],
      dialogVisible: false,
      form: {},
      outwareDate: [],
      total_count: 0,
      out_count: '',
      // loading: false,
    };
  },
  inject: ['reload'],
  methods: {
    addData() {
      sessionStorage.setItem('deliverId', this.deliverId);
      this.$router.push({ name: 'ckaddProduct' });
    },
    // -------------------------------noSubmit
    noSubmit() {
      this.$router.push({ name: 'stockOutDetail' });
    },
    // -----------------------------------修改按钮
    updateData(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          this.name = row.PRODUCT_NAME;
          this.pro_type = row.TYPE_UNIT;
          this.form = row;
          this.out_count = Number(row.NEED_COUNT);
          this.dialogVisible = true;
          const params = {
            PRODUCT_CODE: row.PRODUCT_CODE,
            DELIVER_ID: this.deliverId,
          };
          updatestockDataFun(params).then((result) => {
            this.outwareDate = result[0].DETAIL.map((item, index) => Object.assign(
              item,
              { NEW_COUNT: item.DELIVER_COUNT },
              { PRODUCT_COUNT: row.NEED_COUNT },
            ));
            this.total_count = Number(result[0].TOTAL);
            document.body.style.cursor = 'default';
          })
            .catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {}
      }
    },
    // -------------------------------查询操作
    queryData() {
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('oreder_id')),
      };
      stockOutDetailFun(params).then((result) => {
        if (result[0].DETAIL.length !== 0) {
          this.noWareDate = result[0].DETAIL;
          this.deliverId = result[0].list[0].DELIVER_ID;
          this.updateStatus = result[0].list[0].STATUS;
          this.rowspan();
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // --------------------------修改模态框中的确认按钮
    submit() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const submitArr = this.outwareDate.map((item, index) => ({
            BATCH: item.BATCH,
            PRODUCT_COUNT: item.PRODUCT_COUNT,
            PRODUCT_CODE: item.PRODUCT_CODE,
            NEW_COUNT: Number(item.NEW_COUNT),
            WAREHOUSE_COUNT: Number(item.WAREHOUSE_COUNT),
          }));
          const params = {
            ORDER_ID: Number(sessionStorage.getItem('oreder_id')),
            DELIVER_ID: this.deliverId,
            PRODUCT_ARRAY: submitArr,
          };
          updatestockOutFun(params).then((result) => {
            this.queryData();
            this.reload();
            this.$message.show({ text: '修改成功', type: 'success' });
            this.dialogVisible = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // -------------------------------------全部确认
    allSubmit() {
    },
    // --------------------------行
    rowspan() {
      this.spanArr = [];
      this.noWareDate.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else if (
          this.noWareDate[index].ID === this.noWareDate[index - 1].ID
        ) {
          this.spanArr[this.position] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.position = index;
        }
      });
    },
    // ---------------------------------表格合并行
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 1) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 2) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 3) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 4) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 9) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 8) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    // ------------------------------打印
    print() {
      let html = '<div>';
      html += '<div class="main">';
      html += '<div class="title">信息详情</div>';
      html
        += '<table border="1" cellspacing="0"><div class="el-table__body el-table__header">';
      html
        += '<tr><th style="width: 55px">序号</th><th>产品</th><th>单位</th><th>库存数量</th><th>出库数量</th><th>缺少数量</th></tr>';
      html += '</div><div class="el-table__body">';
      this.noWareDate.forEach((item, index) => {
        html += '<tr style="text-align: center">';
        html += `<td>${index + 1}</td> <td>${item.PRODUCT_NAME}</td><td>${item.TYPE_UNIT}</td><td>${item.WAREHOUSE_COUNT}
        </td><td>${item.NEED_COUNT}</td><td>${item.LACK_COUNT}</td>`;
        html += '</tr>';
      });
      html += '</div>';
      html += '</table>';
      html += '</div>';
      html
        += '<div style="margin-top: 20px; display: flex; flex-direction: row;"><div>操作人：</div></div>';
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
  },
  created() {
    this.queryData();
  },
};
</script>
<style scoped>
.el-select {
  margin-right: 15px;
}

.el-input {
  margin-right: 15px;
  width: 200px;
}

.tableArea {
  margin-top: 20px;
}

i[class^="el-icon"] {
  margin-right: 5px;
  font-size: 16px;
  cursor: pointer;
}

.modify_table td {
  padding: 10px;
}

.item_title {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/stockOutNoDetail.vue